import { render, staticRenderFns } from "./AmsTableExample.vue?vue&type=template&id=2147dc79&scoped=true&"
import script from "./AmsTableExample.vue?vue&type=script&lang=js&"
export * from "./AmsTableExample.vue?vue&type=script&lang=js&"
import style0 from "./AmsTableExample.vue?vue&type=style&index=0&id=2147dc79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2147dc79",
  null
  
)

export default component.exports